import * as React from 'react';
import { PortalSharedExternalLinkView } from '../../../amorg-common';
import { portalClientApi } from '../../../api/portalClientApi';
import { Card } from '../../../designSystem/Card';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { iconName } from '../../../designSystem/icons/Icons';
import { SingleColumnLayout } from '../../_layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { PageHeader } from '../../../designSystem/PageHeader';
import { P } from '../../../designSystem/typography/Body';
import { EmployeePortalPageContext } from '../../_contexts/EmployeePortalPageContext';
import { EmployeePageWrapper } from '../../_pageWrappers/EmployeePageWrapper';
import { PortalListRowItem } from '../_components/PortalListRowItem';

export function PortalLinkListPage(): JSX.Element
{
    return (
        <EmployeePageWrapper>
            <PortalLinkListPageContent />
        </EmployeePageWrapper>
    );
}

function PortalLinkListPageContent(): JSX.Element
{
    const [loading, setLoading] = React.useState(true);
    const [links, setLinks] = React.useState<PortalSharedExternalLinkView[]>([]);

    const ctx = React.useContext(EmployeePortalPageContext);

    React.useEffect(() =>
    {
        const load = async () =>
        {
            const resources = await portalClientApi.getPortalSharedResources();
            const links = resources.filter(resource => resource.resourceType === 'ExternalLink') as PortalSharedExternalLinkView[];
            setLinks(links);
            setLoading(false);
        };

        load();
    }, []);

    return (
        <>
            <PageHeader narrow headerText='Delte links' headerStyle='primary-black' />
        <SingleColumnLayout narrow>
            <>
                <LoadingPageOverlay loading={loading} />

                <Card variant='outlined' flexGrow='1' style={{ width: '100%' }} shadow>
                    <Flex flexDirection='column' gap={16} width='100%'>
                        {links.length === 0 && <P>Ingen links er delt</P>}

                        {links.map(link => 
                            <a href={link.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', width: '100%', color: ctx.colors.text.normal }} key={link.id}>
                                <PortalListRowItem
                                    title={link.title}
                                    description={link.description || undefined}
                                    icon={link.iconName as iconName || 'interface_actions_externalLink'}
                                />
                            </a>
                        )}
                    </Flex>
                </Card>
            </>
        </SingleColumnLayout>
        </>
    );
}